(function () {
  var grid = document.getElementById('AuthorPostsGrid');
  if (!grid) return;

  var posts = Array.prototype.slice.call(grid.querySelectorAll('.js-author-post'));
  var actions = document.getElementById('AuthorPostsActions');
  var btnMore = document.getElementById('AuthorPostsMore');
  var btnAll = document.getElementById('AuthorPostsAll');

  if (!posts.length) return;

  var INITIAL = 6;
  var STEP = 6;
  var visibleCount = 0;

  function setVisible(count) {
    visibleCount = Math.min(count, posts.length);

    posts.forEach(function (el, i) {
      el.style.display = (i < visibleCount) ? '' : 'none';
    });

    // Mostrar/ocultar botones según corresponda
    if (actions) actions.style.display = (posts.length > INITIAL) ? '' : 'none';

    if (btnMore) btnMore.style.display = (visibleCount < posts.length) ? '' : 'none';
    if (btnAll) btnAll.style.display = (visibleCount < posts.length) ? '' : 'none';

    // Si ya están todos visibles, ocultamos contenedor de acciones
    if (actions && visibleCount >= posts.length) {
      actions.style.display = 'none';
    }
  }

  // Init: mostrar 9
  setVisible(INITIAL);

  if (btnMore) {
    btnMore.addEventListener('click', function () {
      setVisible(visibleCount + STEP);
    });
  }

  if (btnAll) {
    btnAll.addEventListener('click', function () {
      setVisible(posts.length);
    });
  }
})();